import jenny_hayes from "./jenny-hayes"
import fiona_wood from "./fiona-wood"
import jeffrey_rosenfeld from "./jeffrey-rosenfeld"
import rob_moodie from "./rob-moodie"
import maithri_goonetilleke from "./maithri-goonetilleke"
import chatu_yapa from "./chatu-yapa"
import sally_graddon from "./sally-graddon"
import jason_lam from "./jason-lam"
import steve_trumble from "./steve-trumble"
import ranjana_srivastava from "./ranjana-srivastava"
import mark_cook from "./mark-cook"
import nick_carr from "./nick-carr"
import peter_choong from "./peter-choong"
import hon_weng_chong from "./hon-weng-chong"
import joe_rotella from "./joe-rotella"
import olivia_lesslar from "./olivia-lesslar"
import rebecca_stewart from "./rebecca-stewart"
import tilman_ruff from "./tilman-ruff"
import glenn_begley from "./glenn-begley"
import anita_elias from "./anita-elias"
import ginni_mansberg from "./ginni-mansberg"
import rinaldo_bellomo from "./rinaldo-bellomo"
import frank_gaillard from "./frank-gaillard"
import grace_dugan from "./grace-dugan"
import tal_rapke from "./tal-rapke"
import sally_bell from "./sally-bell"
import jonathan_king from "./jonathan-king"
import helen_malcolm from "./helen-malcolm"
import peter_morley from "./peter-morley"
import frank_oberklaid from "./frank-oberklaid"
import kelley_withy from "./kelley-withy"
import joseph_proietto from "./joseph-proietto"
import andrew_pattison from "./andrew-pattison"
import michael_bonning from "./michael-bonning"
import yvonne_ho from "./yvonne-ho"
import adir_shiffman from "./adir-shiffman"
import louise_teo from "./louise-teo"
import jim_black from "./jim-black"
import brendan_nelson from "./brendan-nelson"
import yumiko_kadota from "./yumiko-kadota"
import dr_karl from "./dr-karl"
import patrick_mcgorry from "./patrick-mcgorry"
import raffy_halim from "./raffy-halim"
import renee_lim from "./renee-lim"
import richard_di_natale from "./richard-di-natale"
import ashe_coxon from "./ashe-coxon"
import simon_judkins from "./simon-judkins"
import linny_kimly_phuong from "./linny-kimly-phuong"
import tim_read from "./tim-read"
import chandrashan_perera from "./chandrashan-perera"
import kate_tyson from "./kate-tyson"
import exam_edition_1 from "./exam-edition-1"
import exam_edition_2 from "./exam-edition-2"
import michael_levitt from "./michael-levitt"
import murray_esler from "./murray-esler"
import matthew_chan from "./matthew-chan"
import ian_harris from "./ian-harris"
import peter_blamey from "./peter-blamey"
import june_brundell from "./june-brundell"
import skye_kinder from "./skye-kinder"
import bradley_frew from "./bradley-frew"
import melanie_tan from "./melanie-tan"
import brian_spain from "./brian-spain"
import evelyn_chan from "./evelyn-chan"
import katie_allen from "./katie-allen"
import roy_robins from "./roy-robins"
import marian_dover from "./marian-dover"
import jan_coles from "./jan-coles"
import thailand_covidsation from "./thailand-covidsation"
import melissa_kang from "./melissa-kang"
import bronwyn_king from "./bronwyn-king"
import allison_hempenstall from "./allison-hempenstall"
import david_lam from "./david-lam"
import robbie_gillies from "./robbie-gillies"
import khoa_cao from "./khoa-cao"

let blogObject = {};

blogObject.jenny_hayes = jenny_hayes
blogObject.fiona_wood = fiona_wood
blogObject.jeffrey_rosenfeld = jeffrey_rosenfeld
blogObject.rob_moodie = rob_moodie
blogObject.maithri_goonetilleke = maithri_goonetilleke
blogObject.chatu_yapa = chatu_yapa
blogObject.sally_graddon = sally_graddon
blogObject.jason_lam = jason_lam
blogObject.steve_trumble = steve_trumble
blogObject.ranjana_srivastava = ranjana_srivastava
blogObject.mark_cook = mark_cook
blogObject.nick_carr = nick_carr
blogObject.peter_choong = peter_choong
blogObject.hon_weng_chong = hon_weng_chong
blogObject.joe_rotella = joe_rotella
blogObject.olivia_lesslar = olivia_lesslar
blogObject.rebecca_stewart = rebecca_stewart
blogObject.tilman_ruff = tilman_ruff
blogObject.glenn_begley = glenn_begley
blogObject.anita_elias = anita_elias
blogObject.ginni_mansberg = ginni_mansberg
blogObject.rinaldo_bellomo = rinaldo_bellomo
blogObject.frank_gaillard = frank_gaillard
blogObject.grace_dugan = grace_dugan
blogObject.tal_rapke = tal_rapke
blogObject.sally_bell = sally_bell
blogObject.jonathan_king = jonathan_king
blogObject.helen_malcolm = helen_malcolm
blogObject.peter_morley = peter_morley
blogObject.frank_oberklaid = frank_oberklaid
blogObject.kelley_withy = kelley_withy
blogObject.joseph_proietto = joseph_proietto
blogObject.andrew_pattison = andrew_pattison
blogObject.michael_bonning = michael_bonning
blogObject.yvonne_ho = yvonne_ho
blogObject.adir_shiffman = adir_shiffman
blogObject.louise_teo = louise_teo
blogObject.jim_black = jim_black
blogObject.brendan_nelson = brendan_nelson
blogObject.yumiko_kadota = yumiko_kadota
blogObject.dr_karl = dr_karl
blogObject.patrick_mcgorry = patrick_mcgorry
blogObject.raffy_halim = raffy_halim
blogObject.renee_lim = renee_lim
blogObject.richard_di_natale = richard_di_natale
blogObject.ashe_coxon = ashe_coxon
blogObject.simon_judkins = simon_judkins
blogObject.linny_kimly_phuong = linny_kimly_phuong
blogObject.tim_read = tim_read
blogObject.chandrashan_perera = chandrashan_perera
blogObject.kate_tyson = kate_tyson
blogObject.exam_edition_1 = exam_edition_1
blogObject.exam_edition_2 = exam_edition_2
blogObject.michael_levitt = michael_levitt
blogObject.murray_esler = murray_esler
blogObject.matthew_chan = matthew_chan
blogObject.ian_harris = ian_harris
blogObject.peter_blamey = peter_blamey
blogObject.june_brundell = june_brundell
blogObject.skye_kinder = skye_kinder
blogObject.bradley_frew = bradley_frew
blogObject.melanie_tan = melanie_tan
blogObject.brian_spain = brian_spain
blogObject.evelyn_chan = evelyn_chan
blogObject.katie_allen = katie_allen
blogObject.roy_robins = roy_robins
blogObject.marian_dover = marian_dover
blogObject.jan_coles = jan_coles
blogObject.thailand_covidsation = thailand_covidsation
blogObject.melissa_kang = melissa_kang
blogObject.bronwyn_king = bronwyn_king
blogObject.allison_hempenstall = allison_hempenstall
blogObject.david_lam = david_lam
blogObject.robbie_gillies = robbie_gillies
blogObject.khoa_cao = khoa_cao

export default blogObject